import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const instance = axios.create({ baseURL: API, timeout: 20000 });

instance.interceptors.request.use((config) => {
  const token = localStorage.getItem("bd_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// On expired / invalid token, clear and bounce to login instead of letting
// callers show a vague "failed to load" error.
instance.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err?.response?.status === 401) {
      const onAuthPage = /\/login|\/register/.test(window.location.pathname);
      if (!onAuthPage && localStorage.getItem("bd_token")) {
        localStorage.removeItem("bd_token");
        const next = encodeURIComponent(
          window.location.pathname + window.location.search,
        );
        window.location.replace(`/login?next=${next}&expired=1`);
      }
    }
    return Promise.reject(err);
  },
);

export default instance;

export function formatError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const WINDOWS = [
  { value: "fri_am", label: "Friday Morning", short: "Fri AM" },
  { value: "fri_pm", label: "Friday Evening", short: "Fri PM" },
  { value: "sat_am", label: "Saturday Morning", short: "Sat AM" },
  { value: "sat_pm", label: "Saturday Evening", short: "Sat PM" },
];

export function windowLabel(v) {
  return WINDOWS.find((w) => w.value === v)?.label || v;
}
